// src/context/ServicesContextProvider.js
import React, { useState, useEffect } from 'react';
import { axiosInstance } from '../pages/config';
import { ServicesContext } from "./ServiceContextmain"

const ServicesContextProvider = ({ children }) => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Function to fetch services from API
    const fetchServices = async () => {
      try {
        const response = await axiosInstance.get(`/services`) // Replace with actual API URL
        setServices(response?.data?.service);
      } catch (err) {
        setError(err.message || 'Failed to fetch services');
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  return (
    <ServicesContext.Provider value={{ services, loading, error }}>
      {children}
    </ServicesContext.Provider>
  );
};

export default ServicesContextProvider;
